// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iJxu1m_1{display:flex;justify-content:flex-end;margin-top:var(--space)}.hE8GJGp9{margin-top:var(--space);min-width:400px}`, "",{"version":3,"sources":["webpack://./src/form_components/loading/LoadingModal.module.scss"],"names":[],"mappings":"AAAA,UACE,YAAA,CACA,wBAAA,CACA,uBAAA,CAGF,UACE,uBAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionContainer": `iJxu1m_1`,
	"progressContainer": `hE8GJGp9`
};
export default ___CSS_LOADER_EXPORT___;
